import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useGetCaseFile } from '../../../hooks/cases/useCaseFile';
import { notification } from 'antd/lib';
import { APP_TERMS } from '../../../app-terms';
import { Spin } from 'antd';
/**
 * Opens a URL in a new browser context so the download is handled natively
 * (avoids fetching the file again as a blob in JS).
 */
const openDownloadUrl = (url) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

const CaseFileDownloadLink = ({ caseId, objectKey, fileName }) => {
  const { getCaseFile } = useGetCaseFile();
  const [downloading, setDownloading] = useState(false);


  const handleClick = async (e) => {
    if (downloading) return;
    e?.preventDefault();
    e?.stopPropagation();
    try {
      setDownloading(true);
      const response = await getCaseFile(caseId, objectKey, fileName);
      const preSignedUrl = response?.preSignedUrl;

      if (!preSignedUrl) {
        throw new Error('Missing preSignedUrl');
      }

      openDownloadUrl(preSignedUrl);
    } catch (error) {
      notification.error({
        message: APP_TERMS.error_title,
        description: APP_TERMS.download_failed,
        showProgress: false,
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <a
      style={{ textWrap: 'wrap' }}
      className={downloading ? 'text-muted' : ''}
      onClick={handleClick}
      title='Click to download'
    >
      {fileName} <Spin className='ms-2' spinning={downloading}></Spin>
    </a>
  );
};

CaseFileDownloadLink.propTypes = {
  caseId: PropTypes.number,
  objectKey: PropTypes.string,
  fileName: PropTypes.string,
};

export default CaseFileDownloadLink;
